import { Component, OnInit } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss']
})
export class ServerErrorComponent implements OnInit {

  constructor(private snack:MatSnackBarRef<any>) { }

  ngOnInit(): void {
  }

  close(){

    this.snack.dismiss()
    
  }

}
